import {
    INVOICE_RECEIVE,
    INVOICE_ERROR,
    INVOICE_CHANGE_CURRENTPAGE,
    INVOICE_SET_LOADING,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    list: [],
    totalCount: 0,
    errors: {},
    startDate: '',
    endDate: '',
    loading: false
};

export const invoice = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case INVOICE_RECEIVE:
        case INVOICE_CHANGE_CURRENTPAGE:
        case INVOICE_SET_LOADING:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case INVOICE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
